import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useInvalidateOnAliveUpdate} from '@github-ui/use-invalidate-on-alive-update'
import {useAssigneesQuery} from '../components/overview/data/route-queries'
import type {AliveChannels} from '../page-data/payloads/header'
import {useRefetchOnAliveUpdate, type PullRequestAliveData} from './use-refetch-on-alive-update'

const filter = (data: PullRequestAliveData) => Boolean(data.event_updates?.assignees_updated)

export function useAssigneesLiveUpdates(aliveChannels: AliveChannels | undefined): void {
  const {refetch, queryKey} = useAssigneesQuery()
  const dedupeConcurrentRefetches = isFeatureEnabled('merge_status_checks_refetch_dedupe')

  useRefetchOnAliveUpdate(dedupeConcurrentRefetches ? '' : (aliveChannels?.pullRequest ?? ''), refetch, {
    assignees_updated: true,
  })

  useInvalidateOnAliveUpdate(dedupeConcurrentRefetches ? (aliveChannels?.pullRequest ?? '') : '', queryKey, {
    filter,
  })
}
